import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { CCasesDynamiquesPreparationComponent } from './c-cases-dynamiques-preparation.component';
import { AsInstanceOfFormElementModule } from 'src/app/pipes/as-instance-of-form-element/as-instance-of-form-element.module';



@NgModule({
  declarations: [CCasesDynamiquesPreparationComponent],
  imports: [
    ReactiveFormsModule,
    CommonModule,
    IonicModule,
    AsInstanceOfFormElementModule
  ],
  exports: [CCasesDynamiquesPreparationComponent]
})
export class CCasesDynamiquesPreparationModule { }
